module.exports = __webpack_public_path__ + "static/media/blacktea.815f335e.jpg";